import { APP_ID, HOST_ID, PROD_GTM, UAT_GTM } from '@/data/constants';
import { useGetHost } from '@/data/hooks/useRoute';
import { Script } from 'gatsby';
import { store } from '@/data/reducers';
import i18next from '@/i18n/config';
import { useProductName } from '@/utils/product';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { Header } from './Header';

declare global {
  interface Window {
    dataLayer: Array<unknown>;
  }
}
interface LayoutProps {
  children: React.ReactNode;
}

type GTMCodeType = 'GTM-PDHNZCV' | 'GTM-KMCCW2H';

export const Layout = (props: LayoutProps) => {
  const host = useGetHost() || '';
  const GTMCode: GTMCodeType = host.includes(HOST_ID) ? PROD_GTM : UAT_GTM;
  return (
    <Provider store={store}>
      <Script id="first-unique-id">
        {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTMCode}');
            `}
      </Script>
      <I18nextProvider i18n={i18next}>
        <div className="flex min-h-screen flex-col">
          <Header title={useProductName()} />
          {props.children}
        </div>
      </I18nextProvider>
    </Provider>
  );
};
